import RequestBuilder from '../Lib/Requests';

export default class AccountService {
  api = new RequestBuilder();

  buildCurrentAccountRequest(cancelToken) {
    return {
      service: 'account',
      endpoint: '/account/current',
      method: 'get',
      cancelToken,
    };
  }
  async fetchCurrentUserDetails(cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCurrentAccountRequest(cancelToken)
    );
    return data;
  }
  buildOrgUpdateRequest(orgID, data) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}`,
      method: 'put',
      data,
    };
  }
  updateOrgDetails = async (orgID, update) => {
    const { data = {} } = await this.api.request(
      this.buildOrgUpdateRequest(orgID, update)
    );
    return data;
  };
  buildNewUserRequest(orgID, params, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/org/${orgID}/user`,
      method: 'post',
      params,
      service: 'account',
    };
  }
  createNewUser = async (orgID, params, body, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildNewUserRequest(orgID, params, body, cancelToken)
    );
    return data;
  };
  buildDeleteUserRequest(orgID, userID) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/user/${userID}`,
      method: 'delete',
    };
  }
  deleteUser = async (orgID, userID) => {
    const { data = {} } = await this.api.request(
      this.buildDeleteUserRequest(orgID, userID)
    );
    return data;
  };
  buildEditUserRequest({ orgID, userID, ...params }, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/org/${orgID}/user/${userID}`,
      method: 'put',
      params,
      service: 'account',
    };
  }
  editUser = async (params, body, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildEditUserRequest(params, body, cancelToken)
    );
    return data;
  };
  buildResetPasswordRequest(orgID, userID, data) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/user/${userID}/password`,
      method: 'post',
      data,
    };
  }
  resetPassword = async (orgID, userID, body) => {
    const { data = {} } = await this.api.request(
      this.buildResetPasswordRequest(orgID, userID, body)
    );
    return data;
  };
  buildFindUserRequest = (userID, cancelToken) => {
    return {
      service: 'account',
      endpoint: `/account/${userID}`,
      method: 'get',
      cancelToken,
    };
  };
  async findUser(userID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFindUserRequest(userID, cancelToken)
    );
    return data;
  }
  buildUserSearchRequest(orgID, params, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/users/search`,
      method: 'get',
      params,
      cancelToken,
    };
  }
  async searchUsers(orgID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUserSearchRequest(orgID, params, cancelToken)
    );
    return data;
  }
  buildForgotPasswordRequest(data) {
    return {
      service: 'account',
      endpoint: '/resetPassword',
      method: 'post',
      data,
    };
  }
  async forgotPassword(body) {
    const { data = {} } = await this.api.request(
      this.buildForgotPasswordRequest(body)
    );
    return data;
  }

  buildFetchUserPermissionsRequest(orgID, userID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/org/${orgID}/user/${userID}/permissions`,
      method: 'get',
      service: 'account',
    };
  }
  async fetchUserPermissions(orgID, userID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchUserPermissionsRequest(orgID, userID, cancelToken)
    );
    return data;
  }

  buildUpdateUserPermissionsRequest(orgID, userID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/org/${orgID}/user/${userID}/permissions`,
      method: 'put',
      service: 'account',
    };
  }
  async updateUserPermissions(orgID, userID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateUserPermissionsRequest(orgID, userID, body, cancelToken)
    );
    return data;
  }
}
